<template>
  <div>
    <!-- Matrix View Modal -->
    <Transition name="fade">
      <div v-if="open" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75" @click="$emit('close-matrix-modal')"></div>
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <ExclamationTriangleIcon class="h-6 w-6 text-red-600" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold leading-6 text-gray-900">{{ $t("message.matrixOfPatterns") }}</h3>
                  <div class="mt-2">
                    <div class="overflow-x-auto">
                      <table v-if="1 != 0" class="table-fixed w-full text-center">
                        <tbody>
                          <tr>
                            <template v-for="(symbol, idx) in fakePayload" :key="idx">
                              <td class="matrixCell px-4 py-2" v-show="payloadRegex.test(symbol)">
                                {{ symbol }}
                              </td>
                            </template>
                          </tr>
                          <tr v-for="(item, index) in mainMatrixRendered" :key="index">
                            <td class="matrixCell px-4 py-2" v-for="(elem, indexj) in item" :key="indexj">
                              {{ elem }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button type="button"
                class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                @click="$emit('close-matrix-modal')">OK</button>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Print Options Modal -->
    <Transition name="fade">
      <div v-if="print_open" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75" @click="$emit('close-print-modal')"></div>
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-2xl">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                  <PrinterIcon class="h-6 w-6 text-blue-600" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                  <h3 class="text-lg font-medium leading-6 text-gray-900 mb-4">
                    {{ $t("message.printsCaption") }}
                  </h3>
                  <div class="mt-2 space-y-4">
                    <div class="flex items-center">
                      <input id="printDefaultMandala" type="checkbox" :value="printDefaultMandala" @input="$emit('update:printDefaultMandala', $event.target.checked)"
                        :checked="printDefaultMandala"
                        class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                      <label for="printDefaultMandala" class="ml-3 text-sm font-medium text-gray-700">
                        {{ $t("message.colorizedCaption") }}
                      </label>
                    </div>
                    <div class="flex items-center">
                      <input id="printOnlyDigits" :value="printOnlyDigits" @input="$emit('update:printOnlyDigits', $event.target.checked)" type="checkbox" :checked="printOnlyDigits"
                        class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                      <label for="printOnlyDigits" class="ml-3 text-sm font-medium text-gray-700">
                        {{ $t("message.digitsCaption") }}
                      </label>
                    </div>
                    <div class="flex items-center">
                      <input id="printOnlyDots" type="checkbox" :value="printOnlyDots" @input="$emit('update:printOnlyDots', $event.target.checked)" :checked="printOnlyDots"
                        class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                      <label for="printOnlyDots" class="ml-3 text-sm font-medium text-gray-700">
                        {{ $t("message.dotsCaption") }}
                      </label>
                    </div>
                    <div class="flex items-center">
                      <input id="printDotsByNumbers" type="checkbox" :value="printDotsByNumbers" @input="$emit('update:printDotsByNumbers', $event.target.checked)"
                        :checked="printDotsByNumbers"
                        class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                      <label for="printDotsByNumbers" class="ml-3 text-sm font-medium text-gray-700">
                        {{ $t("message.dotsByNumberCaption") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button @click="$emit('go-to-print')" type="button"
                class="inline-flex justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto">
                {{ $t("message.print") }}
              </button>
              <button @click="$emit('close-print-modal')" type="button"
                class="mt-3 inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto">
                {{ $t("message.close") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Help Modal -->
    <Transition name="fade">
      <div v-if="showHelpModal" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75" @click="$emit('close-help-modal')"></div>
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
            <!-- Close X button -->
            <button @click="$emit('close-help-modal')"
              class="absolute top-4 right-4 text-gray-400 hover:text-gray-500 focus:outline-none">
              <XMarkIcon class="h-6 w-6" />
            </button>
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start mb-5">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                  <QuestionMarkCircleIcon class="h-6 w-6 text-blue-600" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 class="text-lg font-semibold leading-6 text-gray-900">
                    {{ $t("message.helpModalTitle") }}
                  </h3>
                </div>
              </div>

              <div class="space-y-6">
                <!-- Step 1 -->
                <div class="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                  <h4 class="text-md font-medium text-blue-800 flex items-center">
                    <span
                      class="flex items-center justify-center w-6 h-6 bg-blue-600 text-white rounded-full text-xs mr-2">1</span>
                    {{ $t("message.step1Title") }}
                  </h4>
                  <p class="mt-2 text-sm text-blue-700">{{ $t("message.step1HelpDetail") }}</p>
                  <div class="mt-3 bg-white p-3 rounded border border-blue-200">
                    <p class="text-sm text-gray-600 italic">{{ $t("message.step1Example") }}</p>
                  </div>
                </div>

                <!-- Step 2 -->
                <div class="bg-indigo-50 p-4 rounded-lg border-l-4 border-indigo-500">
                  <h4 class="text-md font-medium text-indigo-800 flex items-center">
                    <span
                      class="flex items-center justify-center w-6 h-6 bg-indigo-600 text-white rounded-full text-xs mr-2">2</span>
                    {{ $t("message.step2Title") }}
                  </h4>
                  <p class="mt-2 text-sm text-indigo-700">{{ $t("message.step2HelpDetail") }}</p>
                  <ul class="mt-2 text-sm text-indigo-700 list-disc pl-5 space-y-1">
                    <li>{{ $t("message.helpSelectShape") }}</li>
                    <li>{{ $t("message.helpSelectMethod") }}</li>
                    <li>{{ $t("message.helpSelectPatternLength") }}</li>
                    <li>{{ $t("message.helpSelectPalette") }}</li>
                  </ul>
                </div>

                <!-- Step 3 -->
                <div class="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                  <h4 class="text-md font-medium text-purple-800 flex items-center">
                    <span
                      class="flex items-center justify-center w-6 h-6 bg-purple-600 text-white rounded-full text-xs mr-2">3</span>
                    {{ $t("message.step3Title") }}
                  </h4>
                  <p class="mt-2 text-sm text-purple-700">{{ $t("message.step3HelpDetail") }}</p>
                  <p class="mt-2 text-sm text-purple-700">{{ $t("message.helpViewOptions") }}</p>
                </div>

                <!-- Tips -->
                <div class="bg-gray-50 p-4 rounded-lg">
                  <h4 class="text-md font-medium text-gray-800">{{ $t("message.helpTipsTitle") }}</h4>
                  <ul class="mt-2 text-sm text-gray-600 list-disc pl-5 space-y-1">
                    <li>{{ $t("message.helpTip1") }}</li>
                    <li>{{ $t("message.helpTip2") }}</li>
                    <li>{{ $t("message.helpTip3") }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 flex justify-end">
              <button type="button"
                class="inline-flex justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                @click="$emit('close-help-modal')">
                {{ $t("message.gotIt") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
    <!-- Error Modal -->
    <Transition name="fade">
      <div v-if="showErrorModal" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75" @click="$emit('close-error-modal')"></div>
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <ExclamationTriangleIcon class="h-6 w-6 text-red-600" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold leading-6 text-gray-900">{{ $t("message.errorTitle")}}</h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{ errorMessage }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button @click="$emit('close-error-modal')" type="button"
                class="inline-flex justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto">
                {{ $t("message.gotIt") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
    <!-- Confirmation Modal -->
    <Transition name="fade">
      <div v-if="showMandalaConfirmation" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75" @click="$emit('close-confirmation-modal')"></div>
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                  <ExclamationTriangleIcon class="h-6 w-6 text-yellow-600" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold leading-6 text-gray-900">
                    {{ $t('message.previewConfirmationTitle') }}
                  </h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      {{ $t('message.previewConfirmationText') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button type="button"
                class="inline-flex justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto"
                @click="$emit('confirm-create-mandala')">
                {{ $t('message.confirm') }}
              </button>
              <button type="button"
                class="mt-3 inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
                @click="$emit('close-confirmation-modal')">
                {{ $t('message.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { ExclamationTriangleIcon, PrinterIcon, QuestionMarkCircleIcon, XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'Modals',
  components: {
    ExclamationTriangleIcon,
    PrinterIcon,
    QuestionMarkCircleIcon
  },
  props: {
    open: Boolean,
    print_open: Boolean,
    showHelpModal: Boolean,
    showErrorModal: Boolean,
    errorMessage: String,
    showMandalaConfirmation: Boolean,
    fakePayload: String,
    payloadRegex: RegExp,
    mainMatrixRendered: Array,
    printDefaultMandala: Boolean,
    printOnlyDigits: Boolean,
    printOnlyDots: Boolean,
    printDotsByNumbers: Boolean
  }
}
</script>
